/**
 * StatusBadge Component
 * Displays enrollment status as a colored badge
 */

import React from 'react';
import { ENROLLMENT_STATUSES, type EnrollmentStatus } from '../types';

interface StatusBadgeProps {
  status: EnrollmentStatus;
  size?: 'sm' | 'md';
}

// Enrollment-status domain colors (hues are data, not chrome) — normalized to
// the spec pill recipe: bg-{c}-100 text-{c}-800 dark:bg-{c}-900/40 dark:text-{c}-300.
const colorMap: Record<string, string> = {
  yellow: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/40 dark:text-yellow-300',
  green: 'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300',
  gray: 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300',
  blue: 'bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-300',
  red: 'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300',
};

export function StatusBadge({ status, size = 'md' }: StatusBadgeProps) {
  const statusConfig = ENROLLMENT_STATUSES.find(s => s.value === status);
  const label = statusConfig?.label || status;
  const color = statusConfig?.color || 'gray';
  const colorClasses = colorMap[color] || colorMap.gray;

  const sizeClasses = size === 'sm'
    ? 'px-2 py-0.5 text-xs'
    : 'px-2.5 py-0.5 text-xs';

  return (
    <span className={`inline-flex items-center rounded-full font-medium whitespace-nowrap ${colorClasses} ${sizeClasses}`}>
      {label}
    </span>
  );
}

export default StatusBadge;
